import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTestId } from "@/hooks";
import { useRefsContext } from "@/contexts/ref";
import { useMainDescriptionText, useAdditionalDescriptionText, } from "@/components/Sections/Description";
import { Description } from "@/components/Sections/Description/Description";
import { useI18n } from "@/shared/hooks";
import { DescriptionCTA } from "@/components/Sections/Description/DescriptionCTA";
import { Section } from "@/components/UI";
import { Box } from "@gemini/core";
export const MainDescription = () => {
    const MIN_DESCRIPTION_LENGTH = 20;
    const testId = useTestId("Sections.Description.MainDescription");
    const { t } = useI18n();
    const { headline, text } = useMainDescriptionText();
    const { text: additionalDescriptionText } = useAdditionalDescriptionText();
    const { descriptionRef } = useRefsContext();
    const title = t("description.modal.title");
    const shouldDisplayCta = text.length + additionalDescriptionText.length < MIN_DESCRIPTION_LENGTH;
    return (_jsxs(Section, { testId: testId, unsafeClassname: "Description", ref: descriptionRef, children: [_jsx(Description, { testId: testId, headline: headline, text: text, title: title }), shouldDisplayCta && (_jsx(Box, { marginTop: "spacing.16", children: _jsx(DescriptionCTA, {}) }))] }));
};
